import { Col, Container, Row, media } from 'styled-bootstrap-grid';
import { Helmet } from "react-helmet";
import PageTitle from "../../../PageTitle/components/PageTitle";
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import PageNavigation from "../../../PageNavigation/components/PageNavigation";
import GetInTouch from "../../../GetInTouch/components/GetInTouch";
import ViewMoreLink from "../../../ViewMoreLink/components/ViewMoreLink";

const Img = styled.img`
  width: 100%;
`;
const H3 = styled.h3`
  font-weight: 400;
  font-size: 1.7rem;
  margin: 0 0 1rem;
`;
// const InfoTag = styled.p`
//   font-size: 1rem;
//   font-weight: 400;
//   text-transform: uppercase;
//   letter-spacing: 0.2rem;
//   color: #717476;
//   margin: 0 0 0.5rem;
// `;
const P = styled.p`
  color: #717476;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 2.5rem;
`;
const StyledRow = styled(Row)`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;
const StyledCol = styled(Col)`
  margin-bottom: 4rem;
  
  ${media.lg`
    margin-bottom: 0;
  `}
`;

const IndustryTagWrap = styled.div`
  margin-bottom: 4rem;
`;
const IndustryTag = styled.div`
  display: inline-block;
  padding: 0 2rem;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin-right: 1rem;
  height: 3rem;
  border-radius: 2rem;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  line-height: 3rem;
  text-transform: uppercase;
`;

const ServiceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-top: 1px solid #d7d7d7;
`;
const ServiceItem = styled.li`
  display: block;
  border-bottom: 1px solid #d7d7d7;
  padding: 1rem;
`;
const ServiceTag = styled.p`
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 0;
`;
const ServiceName = styled.p`
  color: #212529;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
`;

const LightWrap = styled.div`
  background: #fff;
  padding: ${({padding}) => (padding) ? padding : '4rem 0'};
`;
const TransparentWrap = styled.div`
  padding: 4rem 0;
`;
const NavCol = styled(Col)`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;
const NavSpan = styled.span`
  font-size: 0.8rem;
  padding: 0 2rem;
  vertical-align:top;
`;

const NoCompromiseGaming = (props) => {
  return <Fragment>
    <Helmet>
      <meta name="description" content=""/>
      <title>Case Study: No Compromise Gaming | RMG</title>
      <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
    </Helmet>
    <PageTitle heading="Case Study"
               subHeading="No Compromise Gaming"
    />
    <Container fluid>
      <Row>
        <Col col={12} noGutter={true}>
          <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/ncgaming_hero.png" />
        </Col>
      </Row>
    </Container>
    <Container>
      <StyledRow>
        <StyledCol col={12} lg={6}>
          <IndustryTagWrap>
            <IndustryTag>Electronics</IndustryTag>
            <IndustryTag>Computers</IndustryTag>
            <IndustryTag>Video Games</IndustryTag>
          </IndustryTagWrap>
          <H3>
            About No Compromise Gaming
          </H3>
          <P>
            Founded in 2012, No Compromise Gaming (NCG) is a Nashville-based company built on the idea that it should be easy for gamers to own the computer system of their dreams. They partnered with RMG to align their online brand experience with their mission of empowering PC gamers through innovative buying options, transparent pricing, and excellent support.
          </P>
          <P>
            RMG migrated NCG to a mobile-first design, streamlined the account creation and credit approval journeys, and overhauled their infrastructure. The result for NCG is connecting more gamers to their dream machines without compromise.
          </P>
        </StyledCol>
        <Col col={12} lgOffset={2} lg={4}>
          <H3>
            How We Helped
          </H3>
          <ServiceList>
            <ServiceItem>
              <ServiceTag>Creative</ServiceTag>
              <ServiceName>Mobile Responsive Design</ServiceName>
              <ServiceName>User Experience Design</ServiceName>
              <ServiceName>User Interface Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Development</ServiceTag>
              <ServiceName>B2C & B2B Implementation</ServiceName>
              <ServiceName>Backend Development</ServiceName>
              <ServiceName>Frontend Development</ServiceName>
              <ServiceName>Software Architecture Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Digital Marketing</ServiceTag>
              <ServiceName>Competitive Rank Tracking</ServiceName>
              <ServiceName>Keyword Research</ServiceName>
              <ServiceName>Search Engine Optimization</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Strategy</ServiceTag>
              <ServiceName>Data Visualization</ServiceName>
              <ServiceName>User Feedback &amp; Surveys</ServiceName>
              <ServiceName>User Session Tracking</ServiceName>
            </ServiceItem>
          </ServiceList>
        </Col>
      </StyledRow>
    </Container>
    <LightWrap>
      <Container>
        <Row>
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*  <div><P>As their selection of bags and options continued to grow, Rickshaw partnered with RMG to streamline their online brand experience make it feel like it does in-store. To bring this level of customization online, RMG first replatformed Rickshaw from Magento 1 to Magento 2. During the data migration, RMG made updates to the infrastructure responsible for storing product and customer data, increasing security and functional reliability. These backend updates also allow Rickshaw to rapidly iterate on designs and store their new creations as product/option variations, greatly reducing the time-to-market for new offerings.</P></div>*/}
          {/*  <div><P>This feature immediately gave Rickshaw Bags a huge return on their investment by allowing them to remain open as an essential business and produce facemasks during the COVID-19 pandemic, increasing their pageviews and conversation rate by over 400% and their revenue by almost 500%.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/600x600" /></div>*/}
          {/*  <div><P>After transforming Rickshaw's core digital experience, the same treatment was applied to the rest of the business by adding new shipping methods and options, upgrading their invoice processing, and revamping their blog. Together, these changes help Rickshaw scale their business as their options continue to expand and attract new audiences through their strong content-to-commerce funnel. By working with RMG, Rickshaw Bagworks was able to bring their renowned in-store experience online and expand their reach well beyond their San Francisco storefront.</P></div>*/}
          {/*</Col>*/}
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><P>At the core of Rickshaw's brand experience is the ability to customize a bag's flap, body, inner lining, bindings, buckles, labels, and straps, each of which comes in multiple colors and fabrics. Because of their extraordinary selection, Rickshaw staff's knowledgeable designers to help customers build the best bags based on their needs. In addition, Rickshaw designs and manufactures many custom fabrics, which greatly expands the audiences and applications their products cater to.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/800x1000" /></div>*/}
          {/*  <div><P>On the frontend, RMG built a specialized product customizer which allowed for multiple interacting filters, such as part color and fabric. This customizer also allows customers to make unique, personalized color variations which can be applied across all of Rickshaw's products. In addition, RMG redesigned Rickshaw's entire customer journey to be mobile-first, allowing customers to navigate the customization process with ease regardless of the device they use. As part of this redesign, RMG restyled most of the imagery across the site, even adding support for moving GIF images. We also streamlined Rickshaw's product, catalog, cart, and checkout pages to minimize friction and provide better responsiveness.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*</Col>*/}
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/ncgaming_img_01.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>No Compromise Gaming is known for its innovative rent-to-own program for the latest and most powerful gaming computers, laptops, and accessories. Their flexible payment options and custom credit approval processes are designed to make traditionally expensive machines affordable in an ever-shifting economy. Throughout their customer journey, NCG emphasizes transparent pricing as well as easy to understand product descriptions and configuration options, empowering gamers to get exactly what they want for a price that fits their needs.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>As NCG expanded their inventory and configuration options, they realized they needed a more robust ecommerce platform to manage the increasing complexity of their shopping experience. RMG replatformed NCG to Magento 2 and migrated them onto an Amazon Web Services backend. During the move, RMG optimized the way product information was stored and accessed, increasing security and reliability. On the frontend, RMG leveraged these optimizations by building an intuitive product customizer that accounts for the many component bundles, compatibility rules, and allowable combinations associated with configuring a computer.</P>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/ncgaming_img_03.png" />
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/ncgaming_img_02.png" />
            <P>RMG streamlined the start of No Compromise Gaming's user journey by combining credit applications and lease-approvals with the account creation process. Likewise, the end of the journey features a custom modal shopping cart with the ability to change configurations, purchase add-ons, and read product information without ever leaving the cart itself. This unique end-to-end workflow helps gamers build exactly the computers they want and apply for the right credit and leasing options with minimal friction. In addition, RMG's creative team refreshed imagery, styling, and layouts throughout the entire experience, allowing for smoother navigation, faster content delivery, and better responsiveness.</P>
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <LightWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>After 4 months, No Compromise Gaming launched their newly upgraded ecommerce experience. The focus then turned to site speed improvements and search engine optimization. NCG continues to leverage RMG's SEO specialists for keyword research, competitive rank tracking, content ideation, and link building while the development team focuses on tag management, updating metadata, and optimizing site speed. The combination of these efforts has resulted in more conversions, higher customer satisfaction, and lower bounce rates.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/ncgaming_img_04.png" />
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <LightWrap padding="0">
      <Container>
        <Row>
          <NavCol col={12}>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' directionReversed
                          to={`/portfolio/hum-by-verizon`}
                          buttonText="Hum by Verizon" />
            <NavSpan>/</NavSpan>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' to={`/portfolio/black-ovis`}
                          buttonText="Black Ovis" />
          </NavCol>
        </Row>
      </Container>
    </LightWrap>
    <GetInTouch title="Get In Touch"
                text="You could be our next case study."
                buttonText="Let's talk"
                useArrow
    />
    <PageNavigation prev="capabilities" next="insights" />
  </Fragment>;
};

export default withRouter(NoCompromiseGaming);